.row {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.chip {
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  padding: 0;
  cursor: pointer;
  background-clip: padding-box;
  transition: outline 0.12s ease, transform 0.12s ease;
}

.chip:hover { transform: scale(1.05); }

.chip.selected {
  outline: 2px solid var(--color-ink);
  outline-offset: 2px;
}

.sm .chip { width: 16px; height: 16px; }
.md .chip { width: 22px; height: 22px; }
.lg .chip { width: 30px; height: 30px; }

/* Mobile: card swatches are too small for finger taps and tired eyes;
   bump the small size and widen the gap so they're easier to spot
   and select. md/lg sizes are already comfortable. */
@media (max-width: 768px) {
  .sm { gap: 10px; }
  .sm .chip { width: 26px; height: 26px; }
}
